import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function FeaturedArticles() {
  const featuredArticles = getFeaturedArticles();
  const heroArticle = featuredArticles[0];
  const gridArticles = featuredArticles.slice(1);

  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              热门攻略文章
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              精选最受欢迎的不知火舞攻略内容
            </p>
          </div>
          <Link
            to="/category/combo-guide"
            className="flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mb-8">
          <ArticleCard article={heroArticle} variant="featured" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {gridArticles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}